import { checklistDamages } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.DamageConstant';
import { Row, Col, Typography, Space } from 'antd';
import { ReactComponent as OldCarSides } from '@/assets/images/oldCarSides.svg';
import { WorkOrderChecklistDamage } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { useEffect, useRef } from 'react';

interface Props {
  damageList: WorkOrderChecklistDamage[];
}

const OldChecklist: React.FC<Props> = ({ damageList }) => {
  const oldCarRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (damageList.length) {
      damageList.forEach(setRect);
    }
  }, [damageList]);

  function setRect(damage: WorkOrderChecklistDamage) {
    if (!oldCarRef.current) return;

    const itemIndex = checklistDamages.findIndex(
      (item) => item.label.toLowerCase() === damage.damage.toLowerCase(),
    );

    const damageItem = checklistDamages[itemIndex];

    if (!damageItem) return;

    const svgns = 'http://www.w3.org/2000/svg';

    const g = document.createElementNS(svgns, 'g');

    const x = damage.x - 15;
    const y = damage.y - 15;

    g.setAttribute('x', x.toString());
    g.setAttribute('transform', `matrix(1, 0, 0, 1, ${x}, ${y})`);
    g.classList.add('car-damage');

    const text = document.createElementNS(svgns, 'text');
    text.setAttribute('x', '15');
    text.setAttribute('y', '16');
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('dominant-baseline', 'middle');
    text.setAttribute('fill', 'black');
    text.style.fontSize = '30px';
    text.style.fontWeight = 'bold';
    const textNode = document.createTextNode(damageItem.acronym);

    text.appendChild(textNode);
    g.appendChild(text);
    oldCarRef.current?.appendChild(g);
  }

  return (
    <>
      <Row gutter={[48, 24]}>
        <Col
          span={24}
          md={14}
          style={{ overflowX: 'auto', textAlign: 'center' }}
        >
          <OldCarSides key={damageList?.length} ref={oldCarRef} />
        </Col>

        <Col span={24} md={10}>
          <Typography.Title level={4}>Legendas</Typography.Title>

          <Row gutter={[24, 10]}>
            {checklistDamages.map((item) => (
              <Col span={24} md={12} key={item.value}>
                <Space align="start">
                  <span>{item.acronym}</span>
                  <span>-</span>
                  <span>{item?.label}</span>
                </Space>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default OldChecklist;
